var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"data-list"},_vm._l((_vm.operateGuide.children),function(item,index){return _c('router-link',{directives:[{name:"show",rawName:"v-show",value:(item.isIssue=='0'),expression:"item.isIssue=='0'"}],key:'item4'+index,staticClass:"data-item",attrs:{"to":item.categoryUrl}},[_vm._v(_vm._s(item.categoryTitle)+" ")])}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }